var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngleRightOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49982 16.4591C7.33982 16.4591 7.17979 16.3983 7.05813 16.2758C6.81396 16.0317 6.81396 15.6358 7.05813 15.3916L12.4498 9.99998L7.05813 4.60834C6.81396 4.36417 6.81396 3.96831 7.05813 3.72414C7.30229 3.47997 7.69815 3.47997 7.94232 3.72414L13.7757 9.55747C14.0198 9.80164 14.0198 10.1975 13.7757 10.4417L7.94232 16.275C7.81982 16.3983 7.65982 16.4591 7.49982 16.4591Z",
    fill: "#FF6C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightOrange);
export default __webpack_public_path__ + "static/media/angle-right-orange.3b7459b479d452f3dc4f411c8d4a3ed8.svg";
export { ForwardRef as ReactComponent };